import React from 'react';

import {
    AccordionPanel,
    DisclaimerText,
    Image,
    List,
    ListColumns,
    Text,
} from 'reaxl';

import CalculatorJumpLink from '@/components/vehicledetails/CalculatorJumpLink';

import PsxButton from './PsxButton';
import SubSectionHeader from './SubSectionHeader';

const banks = [
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/chase.jpg',
        label: 'Chase',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/pnc.jpg',
        label: 'PNC',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/boa.jpg',
        label: 'Bank of America',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/usaa.jpg',
        label: 'USAA',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/wellsfargo.jpg',
        label: 'Wells Fargo',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/tdbank.jpg',
        label: 'TD Bank',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/citi.jpg',
        label: 'Citi',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/suntrust.jpg',
        label: 'SunTrust',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/usbank.jpg',
        label: 'US Bank',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/navy.jpg',
        label: 'Navy Federal',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/capitalone.jpg',
        label: 'CapitalOne',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/banks/fidelity.jpg',
        label: 'Fidelity',
    },
];

const cards = [
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/visa_64.png',
        label: 'Visa',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/mastercard_64.png',
        label: 'Mastercard',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/american_express_64.png',
        label: 'American Express',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/discover_64.png',
        label: 'Discover',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/jcb_64.png',
        label: 'JCB',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/diners_club_64.png',
        label: 'Diners Club',
    },
    {
        url: '/cm-api/content/static/img/psx/explainer/cards/debit.jpg',
        label: 'Debit',
    },
];

function ImageTile({ url, label, height, width }) {
    return (
        <Image
            src={url}
            height={height}
            width={width}
            lazyload
            alt={label}
        />
    );
}

function PsxHowToPay({
    onCalculatorJumpLinkClick = () => { },
}) {
    return (
        <AccordionPanel
            title="How to Pay"
            key="payment"
            eventKey="payment"
        >
            <div className="margin-vertical-2">
                <Text weight="bold">Note: </Text>
                Depending on your location and other factors, some payment options may not be available to you.
            </div>
            <SubSectionHeader
                heading="Financing*"
                description="We partner with trusted financial institutions and credit unions to provide attractive financing with competitive rates and flexible terms."
                footer="No fees! Private Seller Exchange does not charge fees to apply for financing."
            />
            <div className="text-center text-sm-left">
                <CalculatorJumpLink
                    bsStyle="secondary"
                    className="margin-bottom-1"
                    label="Estimate Monthly Payments"
                    onClick={onCalculatorJumpLinkClick}
                />
            </div>
            <DisclaimerText className="margin-vertical-3">
                * In some areas, financing may not be an option and only cash payments will be accepted.
            </DisclaimerText>
            <hr />
            <SubSectionHeader
                heading="ACH Direct Payment"
                description="Pay directly from your bank account. We support most banks and credit unions including:"
                footer="Once you&rsquo;ve created an account, you&rsquo;ll be able to use your online banking credentials to verify your bank information."
            >
                <ListColumns
                    items={banks}
                    render={(item) => (
                        <ImageTile
                            {...item}
                            height={50}
                            width={100}
                        />
                    )}
                    className="padding-left-0"
                    xs={3}
                    sm={4}
                    md={6}
                />
            </SubSectionHeader>
            <hr />
            <SubSectionHeader
                heading="Credit or Debit Card"
                description="Spread your purchase across as many cards as you&rsquo;d like. We will accept a maximum of $25,000.00 across debit and credit cards."
            >
                <List
                    items={cards}
                    render={(item) => (
                        <ImageTile
                            {...item}
                            height={64}
                            width={64}
                        />
                    )}
                    className="padding-left-0"
                    decorated={false}
                    inline
                />
            </SubSectionHeader>
            <hr />
            <SubSectionHeader
                heading="Wire Transfer"
                description="We provide our bank account and routing number. Your bank sends us a wire and you pick up your car."
            />
            <hr />
            <PsxButton
                uiContext="makeOffer"
            >
                Make Offer
            </PsxButton>
        </AccordionPanel>
    );
}
export default React.memo(PsxHowToPay);
